import { Component, Input } from '@angular/core';
import { DialogService } from 'src/app/core/services/dialog.service';
import { ICONS } from 'src/app/core/constants/icons';

@Component({
  selector: 'app-page-info',
  templateUrl: './page-info.component.html',
  styleUrls: ['./page-info.component.scss']
})
export class PageInfoComponent {
  @Input() imageURL?: string;
  @Input() title?: string;
  @Input() infoMessage?: string | undefined;

  protected INFO_WHITE = ICONS.INFO_WHITE;

  constructor(private dialogService: DialogService) {}

  openInfoModal() {
    if (this.infoMessage) {
      this.dialogService.openConfirmation('', this.infoMessage);
    }
  }
}
